// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"491":"2cfc6954","2624":"2cfc6954","4536":"9c2b89bf","7930":"2cfc6954","7996":"0778a13a","9147":"d1461f89"}[chunkId] + ".chunk.css";
};